/**
 * Created by wajidafaneh on 5/3/17.
 */
angular
    .module('harriApp')
    .factory('hmapService', ['$q', '$state', '$stateParams', 'hUser', 'userPermissions', 'brandServices', function ($q, $state, $stateParams, hUser, userPermissions, brandServices) {

        var dashboardState = "appLayout.harriSH.access-portal.main";

        var events = {
            "brand_loaded": [],
            "gp_policy_loaded": [],
            "active_brand_changed": [],
            "search_query_changed": []
        };

        var trigger = function (eventName, param1, param2, param3, param4) {
            events[eventName].forEach(function (handler) {
                handler(param1, param2, param3, param4);
            });
        };

        var service = {};
        service.brands = {};
        service.gpPolicies = {};
        service.activeBrand = null;
        service.brandLevelsMap = {};
        service.brandsTree = [];
        service.activeBrandPath = [];
        service.breadcrumbs = [];
        service.subwayBreadcrumb = null;
        var searchTermTimeout;

        //Hold brands data
        service.loadBrand = function (brandId) {
            if (service.brands[brandId]) {
                trigger("brand_loaded", service.brands[brandId]);
            } else {
                ProfileAPI.getBrandProfile(brandId)
                    .then(function (res) {
                        service.brands[brandId] = res;

                        trigger("brand_loaded", service.brands[brandId]);
                    });
            }
        };

        service.loadBrandDetails = function (brandId) {
            var defer = $q.defer();

            if (service.brands[brandId]) {
                defer.resolve(service.brands[brandId]);
            } else {
                ProfileAPI.getBrandProfile(brandId)
                    .then(function (res) {
                        service.brands[brandId] = res;
                        defer.resolve(service.brands[brandId]);
                    })
                    .catch(function (err) {
                        console.error(err);
                    });
            }

            return defer.promise;
        };

        service.onBrandLoaded = function (handler) {
            events["brand_loaded"].push(handler);
        };

        service.onActiveBrandChanged = function (handler) {
            events["active_brand_changed"].push(handler);
        };

        service.onSearchQueryChanged = function (handler) {
            events["search_query_changed"].push(handler);
        };

        service.searchTextUpdated = function (queryText) {
            trigger("search_query_changed", queryText);
        }

        //Load brand ploicy & Queue it so we don't have duplicated requests....
        var loadGPPolicyQueue = {};
        service.loadGPPlociy = function (gpId) {
            loadGPPolicyQueue[gpId] = loadGPPolicyQueue[gpId] || [];

            var deferred = $q.defer();

            if (!service.gpPolicies[gpId]) {
                if(!loadGPPolicyQueue[gpId].length) {
                    UserAPI.getGPPolicy(gpId)
                        .then(function (res) {
                            service.gpPolicies[gpId] = res;
                            trigger("gp_policy_loaded", service.gpPolicies[gpId]);

                            for (var i in loadGPPolicyQueue[gpId]) {
                                loadGPPolicyQueue[gpId][i].resolve(service.gpPolicies[gpId]);
                            }

                            loadGPPolicyQueue[gpId][i] = [];

                        }, function (err) {
                            console.error("couldn't load your gp ploicy");
                            deferred.reject("couldn't load your gp ploicy");
                        });
                }

                loadGPPolicyQueue[gpId].push(deferred);
            } else {
                deferred.resolve(service.gpPolicies[gpId]);
            }


            return deferred.promise;
        };

        service.onGPPolicyLoaded = function (handler) {
            events["gp_policy_loaded"].push(handler);
        };

        service.getActiveBrandId = (hmapPath) => {
            const urlParts = hmapPath ? hmapPath.split("-") : [];
            let activeBrandId;

            if (urlParts.length === 0) {
                activeBrandId = hUser.getUserContext().brand_id;
            } else {
                activeBrandId = parseInt(urlParts[urlParts.length - 1]);
            }

            return activeBrandId;
        };

        //Get active brand usually from the brand
        service.getActiveBrand = function () {

            var urlParts = $stateParams.hmapPath? $stateParams.hmapPath.split("-"): [];
            var activeBrand;

            if (service.activeBrand && !$state.current.name.includes('appLayout.harriSH.access-portal') && urlParts.length === 0) {
                return service.activeBrand;
            }

            if (urlParts.length === 0) {
                //if no url parts are present or the url part represent a settings page then return the top level brand
                activeBrand =  hUser.getUserContext().brand_id;
            } else {
                activeBrand = parseInt(urlParts[urlParts.length - 1]);
            }
            if (activeBrand !== service.activeBrand) {
                service.activeBrand = activeBrand;
                trigger("active_brand_changed",  service.activeBrand);
            }
            return service.activeBrand;
        };

        var prepareBrandsTreeViewData = function (gps, activeBrandPath,enterpriseBrand) {
            var brandsTree = [];
            var breadcrumbs = [];
            var nestedBrandsList = [];
            var highestBrandId = hUser.getUserContext().brand_id;

            for (var key in gps) {
                if (key == gps[key].id) {
                    service.brandLevelsMap[gps[key].id] = {brands: gps[key].brands, type: gps[key].type};
                }
            }

            if (enterpriseBrand) {
                var brandDetails = {};
                var parentId = enterpriseBrand.parent_id;
                var parentBrand = gps[parentId] || service.brandLevelsMap[parentId];

                if (parentBrand && parentBrand.brands && parentBrand.brands.length) {
                    brandDetails = parentBrand.brands.find(function (brand) {
                        return brand.id === enterpriseBrand.id;
                    });
                }
                service.brandLevelsMap[enterpriseBrand.id] = {brands: [brandDetails], type: enterpriseBrand.type};
            }

            for (var id in service.brandLevelsMap) {
                var brandId = parseInt(id);
                if (activeBrandPath.indexOf(brandId) === -1) {
                    delete service.brandLevelsMap[id];
                }
            }

            for (var k = 0; k < activeBrandPath.length; k++) {
                var brandId = activeBrandPath[k];
                brandsTree.push(service.brandLevelsMap[brandId]);
                var url = nestedBrandsList.join("-");

                if (service.brands[brandId] && ['enterprise','child'].indexOf(service.brands[brandId].type) === -1) {
                    breadcrumbs.push(
                        {
                            id: brandId,
                            url: url,
                            href: $state.href(dashboardState, {hmapPath: url}),
                            active: (k === activeBrandPath.length - 1) && $state.current.name === dashboardState,
                            name: service.brands[brandId].name
                        }
                    );
                }

                //exclude highest brand id from active brand path
                if (brandId !== highestBrandId) {
                    nestedBrandsList.push(activeBrandPath[k]);
                }
            }

            return {brandsTree: brandsTree, breadcrumbs: breadcrumbs};
        };

        service.evaluateBrandsList = function (enterpriseBrand) {
            var defer = $q.defer();
            var hmapPath = angular.copy($stateParams.hmapPath);
            var highestBrandId = hUser.getUserContext().brand_id;
            var activeBrandPath = [highestBrandId];
            var promises = {};

            if (hmapPath) {
                var urlParts = (hmapPath && hmapPath.split("-")) || [];

                for (var i = 0; i < urlParts.length; i++) {
                    var brandId = parseInt(urlParts[i]);
                    activeBrandPath.push(brandId);
                }
            }

            if (enterpriseBrand) {
                activeBrandPath.push(enterpriseBrand.id);
            }

            if (!service.brandLevelsMap[highestBrandId]) {
                promises[highestBrandId] = GPSAPI.getGP(highestBrandId);
                promises[highestBrandId + '_details'] = service.loadBrandDetails(highestBrandId);
            }

            for (var j = 0; j < activeBrandPath.length; j++) {
                if (!service.brandLevelsMap[activeBrandPath[j]] && (!enterpriseBrand || enterpriseBrand.id !== activeBrandPath[j])) {
                    promises[activeBrandPath[j]] = GPSAPI.getGP(activeBrandPath[j]);
                    promises[activeBrandPath[j] + '_details'] = service.loadBrandDetails(activeBrandPath[j]);
                }
            }


            $q.all(promises)
                .then(function (res) {
                    var viewData = prepareBrandsTreeViewData(res, activeBrandPath, enterpriseBrand);
                    service.activeBrandPath = activeBrandPath;
                    service.brandsTree = viewData.brandsTree;
                    service.breadcrumbs = viewData.breadcrumbs;
                    defer.resolve({
                        activeBrandPath: activeBrandPath,
                        brandsTree: service.brandsTree,
                        breadcrumbs: service.breadcrumbs,
                    });
                })
                .catch(function (err) {
                    console.error(err);
                    defer.reject(err);
                });

            return defer.promise;
        };

        service.setSubwayBreadcrumb = function (brandName) {
            service.subwayBreadcrumb = brandName;
        }

        service.setSearchTermTimeout = function (callback) {
            clearTimeout(searchTermTimeout);
            searchTermTimeout = setTimeout(callback, 600);
        };

        service.isHighestParent = async (brandId) => {
            const gp = await GPSAPI.getGP(brandId);
            return gp.parent_id === brandId;
        };

        service.checkTeamScheduleUserAccess = function (brandId) {
            const defer = $q.defer();

            userPermissions.getBrandPolicy(brandId)
                .then(function (parser) {
                    const isTeamScheduleServiceEnabled = brandServices.check('TEAM_SCHEDULING', brandId);

                    if (!parser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE) && !isTeamScheduleServiceEnabled) {
                        hAlert($filter("translate")("No access"), `${$filter("translate")("You do not have access to manage this area")}. ${$filter("translate")("If you think this is a mistake")}, ${$filter("translate")("please contact your system administrator")}.`);
                        defer.reject(false);
                    } else {
                        defer.resolve(true);
                    }
                })
                .catch(function (error) {
                    defer.reject(false);
                    console.error(error);
                });

            return defer.promise;
        };

        return service;
    }]);
